import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VIEW_COMMENTS_MODE } from '../model/constants';
import { RuleCommentModel, RuleStipModel } from '../model/rule.model';

@Component({
	selector: 'cv-rule-comment-stip-view-item-component',
	templateUrl: './rule-comment-stip-view-item.component.html',
	styleUrls: ['./rule-comment-stip-view-item.component.scss']
})
export class RuleCommentStipViewItemComponent implements OnInit {
	@Input() viewMode: VIEW_COMMENTS_MODE;
	@Input() item: RuleCommentModel | RuleStipModel;
	@Input() index: number;
	@Input() checked: boolean;
	@Output() selected: EventEmitter<any> = new EventEmitter<any>();
	public isLargeComment = false;
	public viewMore = false;
	public text: string;
	VIEW_COMMENTS_MODE = VIEW_COMMENTS_MODE;

	ngOnInit(): void {
		this.text =
			this.viewMode === this.VIEW_COMMENTS_MODE.COMMENTS
				? this.item['note']
				: this.item['stipulation'];
		if (this.text.length > 180) {
			this.isLargeComment = true;
		}
	}

	/**
	 * On toggle view more.
	 */
	public toggleViewMore(): void {
		this.viewMore = !this.viewMore;
	}

	/**
	 * On stip selected emit the event.
	 * @param $event
	 */
	public onValueChange($event: any): void {
		this.selected.emit({item: this.item, value: $event.target.checked});
	}
}
